import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React, { useRef } from 'react'
import { FileUploader } from 'components/FileUploader'
import { AsyncButton } from 'components/ButtonNew/Button';
import { TemplateUploadSVG } from 'assets/img/template_upload';
import { ButtonResetStyle } from 'components/Button/Button';
import { getTemplateImportSKU, postImportSKU } from 'api/masterStore';
import { showAlert } from 'components/Alert';

export interface ResponseImport {
  file_url:          string;
  total_rows:        number;
  success:           number;
  failed:            number;
  validation_errors: null;
  errors:     ImportError[];
}

interface ImportError {
  row:   number;
  item_id: string;
  error:     string;
}

type ModalImportProps = {
  data: {
    storeId: number;
    type?: string;
    itemName?: string;
  };
  open: boolean;
  onClose: (
    event?: React.SyntheticEvent, 
    reason?: 'backdropClick' | 'escapeKeyDown', 
    result?: ResponseImport
  ) => void;
  // onSubmit?: (file: File) => boolean | Promise<boolean>;
};

export const ModalImportSKU = ({ data, open, onClose }: ModalImportProps) => {
  const [busy, setBusy] = React.useState(false);
  const [fileImport, setFileImport] = React.useState<File | null>(null);

  const downloadTemplate = async () => {
    const res = await getTemplateImportSKU({ storeId: data.storeId, type: data.type, itemName: data.itemName });

    // Create a local URL for the blob
    const href = URL.createObjectURL(res.data);

    // Create a link element, set its attributes, and click it
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', 'template_import_sku.xlsx'); // Set the desired filename
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link and revoking the blob URL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  const uploadFileImport = async () => {
    if (fileImport) {
      // console.log('Uploading file:', fileImport);
      setBusy(true);
      try {
        const formData = new FormData();
        formData.append('qqfilename', fileImport.name);
        formData.append('qqfile', fileImport);
        const result = await postImportSKU(data.storeId, formData);
        // console.log('Import result:', result);
        if (result && result.data.status === 'ok') {
          setFileImport(null);
          onClose(null, undefined, result.data.data);
        }
      } catch (error) {
        if (typeof error.toString() === 'string') {
          showAlert('error', error.toString());
          return;
        }
        onClose(null, undefined, error);
      } finally {
        setBusy(false);
      }
    }
  }

  return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <DialogTitle typography="heading 3" className="font-weight-bold">Import</DialogTitle>
            <DialogContent className="pt-3">
                <Box>
                    <FileUploader
                        isUploading={busy}
                        acceptedFileTypes=".xlsx"
                        onFileSelect={(file) => {
                          setFileImport(file)
                        }}
                        onFileRemove={() => {
                          setFileImport(null)
                        }}
                    />
                </Box>
                <p>Import menggunakan file * .xlsx yang di export dari excel.</p>
                <p className="m-0">Untuk mempermudah pengisian data, gunakan template yang telah kami sediakan : </p>
                <p>
                    <ButtonResetStyle className="text-link" extStyled={{ padding: 0 }} onClick={downloadTemplate}>
                        <TemplateUploadSVG color="#4B68EF" />
                        <span className="ml-1">Template data baru</span>
                    </ButtonResetStyle>
                </p>
            </DialogContent>
            <DialogActions sx={{ padding: '16px' }}>
                <AsyncButton
                    disabled={!fileImport || busy}
                    type="button"
                    color="primary"
                    variant="contained"
                    sx={{ minWidth: '100px' }}
                    onClick={uploadFileImport}
                >
                    Import
                </AsyncButton>
            </DialogActions>
        </Dialog>
  )
}